import React from 'react';
import Hero from './../components/Hero'

export default function Home() {
  return (
    <>
      <Hero />
      <main style={styles.container}>
        <h1 style={styles.heading}>Hi. Yes, truly me, at your service 👋</h1>
        <p style={styles.subtext}>Software Engineer & Independent Consultant</p>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>What I Do</h2>
          <ul style={styles.list}>
            <li>✅ Web applications (React, Next.js, Node)</li>
            <li>✅ Backend systems (Java, Spring Boot, AWS)</li>
            <li>✅ Infrastructure automation (Terraform, Docker, Kubernetes)</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>Let's Work Together</h2>
          <p>
            I'm available for short- or long-term contracting work.
            Reach out at <a href="mailto:hello@aimbisgroup.com">hello@aimbisgroup.com</a>
          </p>
        </section>
      </main>
    </>
  );
}

const styles = {
  container: {
    fontFamily: 'sans-serif',
    maxWidth: '600px',
    margin: '2rem auto',
    padding: '1rem',
    lineHeight: 1.6
  },
  heading: {
    fontSize: '2.5rem',
    marginBottom: '0.2rem'
  },
  subtext: {
    fontSize: '1.2rem',
    color: '#555'
  },
  section: {
    marginTop: '2rem'
  },
  sectionTitle: {
    fontSize: '1.5rem',
    marginBottom: '0.5rem'
  },
  list: {
    listStyleType: 'none',
    paddingLeft: 0,
    margin: 0
  },
};
